import { Component } from '@angular/core';

@Component({
  selector: 'section-container',
  imports: [],
  templateUrl: './section-container.component.html',
  styleUrl: './section-container.component.scss'
})
export class SectionContainerComponent {

}
